module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d6e1818"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c7_r1#d7e1791",
      "id": "d14e174"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d6e1868"
    }
  }, [_c('span', {
    staticClass: "ic",
    attrs: {
      "id": "d14e177"
    }
  }, [_c('b', [_vm._v("I")])]), _vm._v("t was one of those golden October afternoons when the temperature was warm but no longer oppressive, and the air held just a hint of the winter’s moisture. A faint breeze stirred the scent of the ornamental orange trees. In the center of the courtyard, a fountain splashed over a bronze base into a channel lined with brightly colored tiles, whose geometric patterns matched the tiles of the walls. The rustle of the leaves, and the sound of the water were loud enough to mask the swish of Doña Rosalia’s skirt over the terrazzo, but they could not quite drown out her angry muttering. “Fools, ingrates! Who do they think they are?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e2388"
    }
  }, [_vm._v("Doña Rosalia crossed the patio quickly, ignoring its beauty as the familiar background of the last sixty-odd years. “Would never have stood for such a thing in my day . . . won’t be allowed to get away with it,” she muttered. She reached a massive wooden door at the far end, pulled back the heavy bolt, and unlocked it with a set of keys hanging from a chain around her waist. The keys would not have looked out of place on a medieval chatelaine. Doña Rosalia’s dress, though no more than forty years out of style, also somehow managed to convey a sense of dignified antiquity. Something in the ample black skirt mocked the flightiness of twentieth-century innovation. “. . . show them all, if I do have to tell the Guardia. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e2948"
    }
  }, [_vm._v("The door swung shut behind Doña Rosalia and the old  woman began climbing the stairs quickly, considering her age. She was breathing hard when she reached the end of the second flight, and she leaned against the wall for a moment to catch her breath. Then she headed down the hallway, keeping one hand on the wall for support, unlocked another door, and stumbled forward, catching at a bell pull. An observer might almost have thought that she had grabbed the bell pull for balance, but her repeated vicious jerks on the tattered silk would have belied such an impression immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e3459"
    }
  }, [_vm._v("When María José opened the door a few minutes later, Doña Rosalia was sitting at an open writing desk, apparently absorbed in a letter. “Well? What took you so long, girl?” she demanded, as the maid bobbed a curtsy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e3719"
    }
  }, [_vm._v("“I’m sorry, Señora.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e3809"
    }
  }, [_vm._v("The old woman brushed aside the apology. “Tell Alberto to summon the Guardia.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e3909"
    }
  }, [_vm._v("“Would you like to telephone them yourself, Señora?” María José asked hopefully.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e4089"
    }
  }, [_vm._v("“Don’t you dare telephone them!” Doña Rosalia snapped. “I told you to send Alberto to get them! You never know who’s listening on the telephone. I don’t want to announce to the entire city that I’m sending for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e4319"
    }
  }, [_vm._v("María José kept her expression blank. “Should Alberto give them any special message, Señora?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e4479"
    }
  }, [_vm._v("“Special message! Huh! Wouldn’t you like to know? Prying into the affairs of your betters, peeping and spying on me!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e4579"
    }
  }, [_vm._v("“I only meant that the Guardia are always busy, Señora, and I don’t think they’ll come if—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e4709"
    }
  }, [_vm._v("“Criminals!” Doña Rosalia hit the arm of her chair with one hand. “You don’t want the Guardia to come because you’re all afraid of them. Thieves and black marketeers, and you think your precious secrets are worth more than my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e4949"
    }
  }, [_vm._v("“No, Señora.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e5049"
    }
  }, [_vm._v("“Ingrates!” Doña Rosalia’s face was becoming flushed. “I take  you into my home, give you work in these times, and this is how you repay me! With larceny and disobedience! I will be obeyed in my own house, girl!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e53010"
    }
  }, [_vm._v("“Yes, Señora. Alberto will get the Guardia, Señora.” María José spoke soothingly, as to a child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e55010"
    }
  }, [_vm._v("Abruptly, the fight seemed to go out of Doña Rosalia. She slumped in her chair. “What’s the point?” She choked slightly. “They’ll get me, sooner or later. You’re all in league against me. You all want me dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e57110"
    }
  }, [_vm._v("“Oh, no, Señora,” María José protested. Then, since the white lie bothered her conscience, she added, “I’m sure no one is trying to kill you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e59110"
    }
  }, [_vm._v("“So it’s all in my head, is it? So I’m a crazy old woman who can’t see what’s in front of her nose? That’s what you think of me? That’s what everyone thinks of me! That I’m too foolish to see what’s going on!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e60810"
    }
  }, [_vm._v("“No, Señora.” María José spoke hastily. “Please, remember what the doctor said about getting excited the last time he checked your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e62810"
    }
  }, [_vm._v("“He’s an idiot. He thinks I’m a helpless fool, just like the rest of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e63810"
    }
  }, [_vm._v("“I’ll go tell Alberto, Señora.” María José curtsied again and made a quick escape.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e65510"
    }
  }, [_vm._v("Doña Rosalia made a disgusted noise as the door closed and then returned to her writing. She scribbled furiously for the better part of an hour, until someone knocked at the door. “Go away,” she shouted. “I left orders not to be disturbed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e67710"
    }
  }, [_vm._v("The door swung open. “It’s Sergeant Rivas, Señora,” María José told her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e69610"
    }
  }, [_vm._v("“It took you long enough!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e70410"
    }
  }, [_vm._v("Sergeant Rivas saluted. “Good afternoon, Doña Rosalia. I understand you are in need of some assistance?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e72210"
    }
  }, [_vm._v("“It’s a plot, Sergeant! I’ve told you before. They’re trying to kill me!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e73511"
    }
  }, [_vm._v("Sergeant Rivas liked to think that the Guardia Civil were the best and brightest in Spain. He comforted himself with the thought that the best and brightest showed no emotion even under the most trying of circumstances. “Who would this be exactly, Doña Rosalia?” he asked politely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e76211"
    }
  }, [_vm._v("“The Reds, of course! They want to kill me because of what I know, but it’s worse this time.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e77211"
    }
  }, [_vm._v("“Of course we’re very interested in any criminal activity, Doña. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e78411"
    }
  }, [_vm._v("“No, you’re not!” she snapped. “You’re annoyed with me for bothering you. In the old days we had justice. But now the Guardia only care about their own comfort.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e79711"
    }
  }, [_vm._v("Had anyone else made the comment, the sergeant would have pricked up his ears and quietly reported it to the officer in charge of the political section. In the case of Rosalia de Ordoñez, he tried to be selectively deaf. “We’ll keep a sharp eye out,” he promised, hoping that she would be easily pacified this time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e82611"
    }
  }, [_vm._v("“Quite a promise from a man who’s as good as blind! It’s no wonder that the Reds are thriving now, when the Guardia are such idiots. But they’re clever, too. They’re very clever. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e83911"
    }
  }, [_vm._v("She had lost two of her sons in the Civil War, torn to death by mobs of enraged peasants, the sergeant reminded himself. Three grandsons had been killed in the attack on Mallorca, and another—a fighter pilot—had died fighting the Russians, in ’41. It was only to be expected that an elderly lady would feel unsafe. He just wished that she was less irritating.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e87111"
    }
  }, [_vm._v("“They suborn people, Sergeant,” she was saying earnestly now. “Even my nearest and dearest, people I’ve always thought I could trust. They’re in on it, too!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e88411"
    }
  }, [_vm._v("“I can’t believe—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e89111"
    }
  }, [_vm._v("“You might look at your own post, Sergeant!” she interrupted. “Or you would, if the Guardia were any better than lazy fools.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e90912"
    }
  }, [_vm._v("“Yes, Doña Rosalia.” One of Rosalia de Ordoñez’s few virtues, from Sergeant Rivas’s point of view, was that she kept an excellent cook. Based on previous experience, he and his colleagues had worked out a rough scale of unofficial compensation for visits to her house. Fifteen minutes merited a glass of wine. Half an hour merited a glass of wine and a pastry or a loaf of fresh bread, if it was available. An hour was a meat dish. Anything over an hour was a full meal, or (since Doña Rosalia always seemed to work herself into a state of agitation over the siesta, and send for the Guardia in the early evening) a set of mixed "), _c('i', [_vm._v("tapas ")]), _vm._v("and drinks. Doña Rosalia’s staff had never argued the point, although the sudden diminution of foodstuffs frequently laid them open to furious tirades about the ingratitude of the Moors and Gypsies she had taken into her home out of the goodness of her heart. Whether they simply feared the Guardia Civil more than their lady or whether they had some sympathy for the harassed guardias who, after encountering Doña Rosalia in a rage, showed up in the kitchen calling for a drink, was not something Sergeant Rivas had ever bothered to consider. Doña Rosalia was exceptionally agitated this evening, and Sergeant Rivas, who had had other work to do, gradually relaxed, as he realized that he would be having dinner at the Casa Ordoñez. He let her ramble on without listening too closely, wondering if there would be any of the stuffed olives that he liked this evening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e104312"
    }
  }, [_vm._v("The sergeant visited the Casa Ordoñez more frequently than most of his colleagues. His mother’s parents and brothers worked on the estates of Don Antonio Ordoñez Guzmán; his mother’s family had farmed the Ordoñez lands for longer than anyone could remember. Perhaps because of this, Doña Rosalia seemed to like the sergeant. To put it more accurately, since she could hardly be said to "), _c('i', [_vm._v("like ")]), _vm._v("him, she seemed inclined to trust him. When Doña Rosalia had first started to call the Guardia, claiming that people were conspiring to kill her, Sergeant Rivas  had responded quickly and personally because he was worried that the threat might be real. Señora de Ordoñez had been recently widowed and was a woman of wealth. Her background was aristocratic, her politics were impeccable, and her death from anything other than natural causes would have been highly embarrassing. Rivas had quickly come to the conclusion that the mysterious threats were delusions and had attempted to delegate the problem the next time it arose. Doña Rosalia had exploded into his office at the post a few hours later, weeping and furious, and berated him for the better part of an hour. She had then nearly blighted the careers of the two young guardias he had sent to deal with her by denouncing them as Reds. A cautious appeal to her son had cleared the guardias’ records, but Sergeant Rivas’s tentative suggestion that Doña Rosalia might feel less threatened if she were living with family instead of alone had been met with a firm command to mind his own business. Over the last three years, Sergeant Rivas had dealt with the conspiracy against Doña Rosalia de Ordoñez alone or with the help of subordinates he thought were overeager and needed to be taken down a peg or two.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e121713"
    }
  }, [_vm._v("He finally escaped a little after seven that evening by promising to report the matter to his lieutenant and to put a guard around the house. Stuffed olives and fresh bread were waiting for him in the kitchen. He appreciated the attention, although he would have liked the chance to chat with Luisa, the cook’s pretty assistant. She showed up a few minutes later. “Do you need anything else, Sergeant?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e124813"
    }
  }, [_vm._v("“Are there anchovies?” he asked hopefully.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e125513"
    }
  }, [_vm._v("“I’m sorry, Sergeant. We didn’t know you were coming until too late. But there’s shrimp in vinegar or cured ham, if you’d like.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e126513"
    }
  }, [_vm._v("Rivas considered. “Ham,” he said finally. “If it’s from your own farm.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e127813"
    }
  }, [_vm._v("“Not ours, Sergeant.” Luisa was apologetic. “But Señor Tejada’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e129814"
    }
  }, [_vm._v("“Good enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e130514"
    }
  }, [_vm._v("Luisa turned toward the pantry without saying anything more, and Sergeant Rivas, who wanted to make conversation, looked for a change of subject. “She’s in a foul mood today, isn’t she?” he remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e132614"
    }
  }, [_vm._v("“Yes, sir.” Even muffled by the pantry door, Luisa’s agreement was heartfelt. “Ever since Señor Tejada left this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e134414"
    }
  }, [_vm._v("“I’d think a visit from her nephew would cheer her up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e135114"
    }
  }, [_vm._v("“She doesn’t get along with his wife, Doña Consuela,” Luisa explained. “Never has, they say.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e136914"
    }
  }, [_vm._v("Sergeant Rivas nodded, wondering absently if Doña Rosalia got along equally badly with her daughter-in-law, and her own daughter. He’d heard that her bachelor son, Felipe, had absolutely refused to live with his mother. “A shame she doesn’t have any family she’s close to,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e139914"
    }
  }, [_vm._v("“She’s never had much use for them, I think. Always quarreling with this one or that one, even before Señor Ordoñez passed away and she became so—” The girl stopped abruptly and flushed as she realized that she had been betrayed into an indiscreet comment. The rest of the sentence was unnecessary anyway. Sergeant Rivas knew perfectly well what she was trying to say. “She was in an even worse mood after Señorito Felipe left on Friday,” Luisa finished, embarrassed. The bell in the kitchen suddenly rang violently, and the girl started. “That’s her. I have to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e145014"
    }
  }, [_vm._v("Sergeant Rivas had finished his meal and departed by the time Luisa took a tray up to Doña Rosalia’s room. The old woman greeted her with a mixture of irritation and relief. “What took you so long? I was beginning to think they’d cut the bell cord, so that I couldn’t call for help!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e148014"
    }
  }, [_vm._v("“I’m sorry, Señora.” Luisa, who was only responsible for bringing Doña Rosalia her meals, wondered as she always did how poor María José managed to deal with the señora all day long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e151214"
    }
  }, [_vm._v("“Taste it,” Doña Rosalia commanded as Luisa set the tray down. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e152514"
    }
  }, [_vm._v("Luisa sighed. “It’s just come up from the kitchen, Señora. I  helped make it myself. And I didn’t meet anyone on the way up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e154315"
    }
  }, [_vm._v("No one could have tampered with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e155015"
    }
  }, [_vm._v("“Taste it!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e155715"
    }
  }, [_vm._v("Luisa shrugged and took a bite of everything on the plate, taking perhaps a larger mouthful of the ham Sergeant Rivas had already enjoyed than was strictly necessary. It really was very good, and the taste of meat was still rare enough. Doña Rosalia watched her carefully to be sure that she swallowed everything and then nodded her satisfaction. “All right. Tell María José I don’t want to be disturbed this evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e159815"
    }
  }, [_vm._v("“Yes, Señora.” Luisa left, thankful that nothing worse had happened, and went to find María José.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e161715"
    }
  }, [_vm._v("“She’ll feel better after she eats probably,” Doña Rosalia’s maid said optimistically, when she heard Luisa’s message. “I’ll go up and put her to bed later, and maybe in the morning she’ll be more calm.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e164215"
    }
  }, [_vm._v("“God willing!” said Luisa emphatically. “I don’t know how you stand it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e165515"
    }
  }, [_vm._v("“I’ve been with her a long time.” María José’s voice was tolerant. “You don’t remember what she was like before Señorito Ramón died. And in spite of that—in spite of everything—she was good to us during the war. We’ve never gone hungry.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e168115"
    }
  }, [_vm._v("Luisa, whose private opinion was that it would have been a good thing if the war had rid the country of Doña Rosalia and all her like, nodded obediently, mumbled something like an assent, and said good night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e170415"
    }
  }, [_vm._v("María José waited until a little after eleven and then went upstairs to Doña Rosalia’s room. She knocked and waited a few moments in silence. No one screeched at her to go away. She pushed open the door, relieved that she had not come too early, and braced herself for Doña Rosalia’s angry cry, “What took you so long?” The silence was unbroken.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e174115"
    }
  }, [_vm._v("Doña Rosalia was sitting at her writing desk, her head tilted away from the door, her arms slack. The dinner tray had been  pushed to one side, most of its contents eaten. María José, who knew that her lady hated being caught asleep by anyone, stepped forward loudly, clearing her throat, so that the old woman would have time to wake up and pretend that she had not been sleeping. Then María saw that a wineglass was lying on the writing desk, with a few drops of red liquid still caught in the bulb. Afraid that they might spill, she advanced more quickly and then gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e179316"
    }
  }, [_vm._v("The wineglass had clearly been at least half full. Wine had soaked Doña Rosalia’s papers and made a dark stain on the wood before dripping into her lap to make a wet spot on her dress. Doña Rosalia’s mouth and eyes were open. A little fearfully, María José reached out to touch the old woman’s shoulder. Then she crossed the room, picked up a mirror, and held it against the open mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e183516"
    }
  }, [_vm._v("There was a telephone in the living room. But María José had been Doña Rosalia’s maid for many years, and habit—or respect for her wishes—died hard. She ran out of the room and down the hallway, crying breathlessly, “Alberto! Alberto, get the Guardia!” Only after she had shooed a reluctant Alberto off to find Sergeant Rivas again did she go to the telephone to call the doctor. It seemed a secondary concern. Rosalia de Ordoñez was clearly past his help.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0c36dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pawe_9781569477786_epub_c8_r1.vue
// module id = 78
// module chunks = 0